<template>
    <div class="tag-list" v-for="(tag, i) in tags" :key="i">
        <el-icon class="tag-overlay-icon"><PriceTag /></el-icon>
        <router-link v-if="tag.title" :to="'/'+tag.title" class="tag">
            {{tag.title}}
        </router-link>
        <p v-if="tag.description">{{tag.description}}</p>
        <ul>
            <li class="d-flex align-center flex-wrap justify-content-between">question <span>{{tag.count}}</span></li>
            <li><a class="d-flex align-center flex-wrap justify-content-between" href="#">today asked <span>{{tag.todayAsk}}</span></a></li>
            <li><a class="d-flex align-center flex-wrap justify-content-between" href="#">this week <span>{{tag.thisWeek}}</span></a></li>
        </ul>
    </div>
</template>


<script>
import {PriceTag} from '@element-plus/icons-vue'

export default {
    name: 'TagList',
    props: ['tags'],
    components: {
        PriceTag
    },
    data() {
        return {

        }
    }
}
</script>